// Имя cookie сессии Supabase — одно для браузера и сервера.
//
// По умолчанию supabase-js строит его из адреса Supabase: sb-<первая часть
// хоста>-auth-token. В dev браузер ходит через same-origin прокси
// (`<origin>/supabase`, см. client.ts), а сервер — напрямую по
// NEXT_PUBLIC_SUPABASE_URL. Открыли приложение на localhost — браузер писал
// sb-localhost-auth-token, сервер искал sb-10-auth-token (LAN-IP из .env):
// вход «проходил», но сервер не видел сессию и возвращал на страницу входа
// (найдено 2026-09-11 при проверке регистрации из разговорника). Работало
// только с LAN-IP, где имена случайно совпадали.
//
// Имя берётся от NEXT_PUBLIC_SUPABASE_URL — ровно то, что сервер и так
// использовал, поэтому уже вошедшие пользователи не разлогиниваются.
export function supabaseCookieName(): string {
  const url = process.env.NEXT_PUBLIC_SUPABASE_URL ?? ''
  let host = 'local'
  try {
    host = new URL(url).hostname.split('.')[0] || host
  } catch {
    // пустой/битый URL — клиент всё равно не заработает, имя не важно
  }
  return `sb-${host}-auth-token`
}
